const asBool = (value: string | undefined): boolean => value === 'true';

export interface ConfigState {
    backend: {
        AUTHENTICATION_SERVICE: string | undefined;
        MENU_SERVICE: string | undefined;
        CONFLOGIC_SERVICE: string | undefined;
        CONFLOGIC_PATH: string | undefined;
        TEMPLATES_SERVICE: string | undefined;
        TEMPLATES_PATH: string | undefined;
        ACCESS_TOKEN_SERVICE: string;
        ACCESS_TOKEN_PATH: string;
        confLogic: {
            CONFLOGIC_SERVICE: string | undefined;
            CONFLOGIC_PATH: string | undefined;
        };
        templates: {
            TEMPLATES_SERVICE: string | undefined;
            TEMPLATES_PATH: string | undefined;
        };
        translation: {
            TRANSLATION_SERVICE: string;
            TRANSLATION_PATH: string;
            VERSIONS_PATH: string;
            TRANSLATION_KEYS_PATH: string;
        };
    };
    homeRoute: string | undefined;
    id: string | undefined;
    login: {
        authority: string | undefined;
        resource: string | undefined;
        clientId: string | undefined;
        oauthScope: string[];
        mockAuthorization: boolean;
        // mockLocale: string | undefined;
        // mockTenant: string | undefined;
        preventRedirect: boolean;
        redirectUri: string | undefined;
        silentRedirectUri: string | undefined;
    };
    serviceVersion: string;
    serviceEnvironment: string;
    enableMockServer: boolean;
    logoutUri: string | undefined;
    sentryToken: string | undefined;
    sentryModuleName: string;
}

export const config: ConfigState = {
    backend: {
        AUTHENTICATION_SERVICE: import.meta.env.VITE_AUTHENTICATION_SERVICE,
        MENU_SERVICE: import.meta.env.VITE_MENU_SERVICE,
        CONFLOGIC_SERVICE: import.meta.env.VITE_CONFLOGIC_SERVICE,
        CONFLOGIC_PATH: import.meta.env.VITE_CONFLOGIC_PATH,
        TEMPLATES_SERVICE: import.meta.env.VITE_TEMPLATES_SERVICE,
        TEMPLATES_PATH: import.meta.env.VITE_TEMPLATES_PATH,
        ACCESS_TOKEN_SERVICE: import.meta.env.VITE_ACCESS_TOKEN_SERVICE,
        ACCESS_TOKEN_PATH: import.meta.env.VITE_ACCESS_TOKEN_PATH,
        confLogic: {
            CONFLOGIC_SERVICE: import.meta.env.VITE_CONFLOGIC_SERVICE,
            CONFLOGIC_PATH: import.meta.env.VITE_CONFLOGIC_PATH,
        },
        templates: {
            TEMPLATES_SERVICE: import.meta.env.VITE_TEMPLATES_SERVICE,
            TEMPLATES_PATH: import.meta.env.VITE_TEMPLATES_PATH,
        },
        translation: {
            TRANSLATION_SERVICE: import.meta.env.VITE_TRANSLATION_SERVICE,
            TRANSLATION_PATH: import.meta.env.VITE_TRANSLATION_PATH,
            VERSIONS_PATH: import.meta.env.VITE_VERSIONS_PATH,
            TRANSLATION_KEYS_PATH: import.meta.env.VITE_TRANSLATION_KEYS_PATH,
        },
    },
    homeRoute: import.meta.env.VITE_HOME_ROUTE,
    id: import.meta.env.VITE_ID,
    login: {
        authority: import.meta.env.VITE_LOGIN_AUTHORITY,
        clientId: import.meta.env.VITE_LOGIN_CLIENT_ID,
        resource: import.meta.env.VITE_LOGIN_CLIENT_ID,
        oauthScope: ['openid', 'profile', 'email'],
        mockAuthorization: false, //import.meta.env.DEV,
        // mockLocale: false, //import.meta.env.VITE_LOGIN_MOCK_LOCALE,
        // mockTenant: false, //import.meta.env.VITE_LOGIN_MOCK_TENANT,
        preventRedirect: asBool(import.meta.env.VITE_LOGIN_PREVENT_REDIRECT),
        redirectUri: import.meta.env.VITE_LOGIN_REDIRECT_URI,
        silentRedirectUri: import.meta.env.VITE_LOGIN_SILENT_REDIRECT_URI,
    },
    serviceVersion: APP_VERSION,
    serviceEnvironment: import.meta.env.MODE,
    enableMockServer: import.meta.env.DEV,
    logoutUri: import.meta.env.VITE_LOGOUT_URI,
    sentryToken: import.meta.env.VITE_SENTRY_DSN,
    sentryModuleName: 'starterTemplate',
};
